import { Injectable, Inject } from '@angular/core';
import { RuleProvider } from './rule-providers/base-rule-provider';
import { MedicalRuleProvider } from './rule-providers/medical-rule-provider';
import { PhysiotherapyRuleProvider } from './rule-providers/physiotherapy-rule-provider';

@Injectable({ providedIn: 'root' })
export class RuleProviderRegistry {
    private providers: RuleProvider[] = [];

    constructor(
        private medicalProvider: MedicalRuleProvider,
        private physioProvider: PhysiotherapyRuleProvider
    ) {
        // Register all available providers
        this.providers = [
            this.medicalProvider,
            this.physioProvider
        ];
    }

    /**
     * Get the appropriate rule provider for a given discipline code
     */
    getProvider(disciplineCode: string): RuleProvider {
        const provider = this.providers.find(p => p.canHandle(disciplineCode));
        
        if (!provider) {
            console.warn(`No rule provider found for discipline code: ${disciplineCode}. Falling back to medical provider.`);
            return this.medicalProvider; // Fallback to medical provider
        }
        
        return provider;
    }

    /**
     * Get all available providers
     */
    getAllProviders(): RuleProvider[] {
        return this.providers;
    }

    /**
     * Register a new rule provider
     */
    registerProvider(provider: RuleProvider): void {
        this.providers.push(provider);
    }

    /**
     * Get supported discipline codes
     */
    getSupportedDisciplines(): string[] {
        return this.providers.map(p => p.disciplineCode);
    }
} 